/*global Adcurve, routie */
Adcurve.onLoad(function(){
  routie(Adcurve.Routes.generate('setting', ['general', 'costs', 'connection', 'tags', 'bidgroups', 'admin']));
  routie(Adcurve.Routes.generate('shop-settings', ['general', 'upload']));
  routie(Adcurve.Routes.generate('users', ['active', 'blocked']));
  routie(Adcurve.Routes.generate('subs', ['noprice', 'cancelled', 'trial']));
  routie(Adcurve.Routes.generate('tips', ['all-list', 'ROI-list', 'MAPPING-list', 'CONTENT-list', 'MANUAL-list', 'MAX_CPC-list']));
  routie({ 'channel/:channelID/industry/:industryID': Adcurve.Routes.availablePublishersRoutes});
});
